import { render, staticRenderFns } from "./organism.swatches.vue?vue&type=template&id=286268ce"
import script from "./organism.swatches.vue?vue&type=script&lang=ts"
export * from "./organism.swatches.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports